import React, { useState } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { getRemotedbUrl, i18nIntl, isNotEmpty, getDeviceFromUserAgent } from '../../lib/ep.js';
import { useFilterDataQuery, usePaginator, operators, useFilterData } from '../FilterContent';
import { useOwner } from '../context/context.js';

import { SquaredButton } from '../builder/ActionButton.js';
import ActionLink from '../builder/ActionLink.js';
import ButtonCollection from '../builder/ButtonCollection.js';
import FloatingLayer from '../builder/FloatingLayer.js';
import RawDataViewer from '../builder/RawDataViewer.js';
import RibbonCollection from '../ui_items/RibbonCollection.js';
import SearchField from '../builder/SearchField.js';
import Select from '../builder/Select.js';
import TabledItemsList, { Column } from '../builder/TabledItemsList.js';
import Tooltip from '../builder/Tooltip.js';

import Module from '../ui_items/Module.js';
import Paginator from '../utils/Paginator.js';

import SingleRegisteredEntry from '../backend/SingleRegisteredEntry.js';
import IPDetail from './IPDetail.js';
import { AlertTypes, SecurityUserAction } from './SecurityCenter.js';
import ModuleHeader from '../ui_items/ModuleHeader.js';
import Spinner from '../builder/Spinner.js';

const date_format = 'DD MMM YYYY, HH:mm';

const VotedDetailLayer = ({ participant_id, stage_id, ...props }) => {
	const [ display_detail_layer, setDisplayDetailLayer ] = useState(false);

	const openDetailLayer = () => {
		$.get(getRemotedbUrl(`/users/get_full_view_data_from_vote/${props.promotion_id}/${stage_id}/${participant_id}`), (res) => {
			if(res.status == '1') {
				setDisplayDetailLayer(res.data);
			}
		}, 'JSON');
	};

	return (
		<>
			<strong>{props?.name ?? participant_id}</strong>
			{/*
			<ActionLink
				onClick={() => openDetailLayer(participant_id)}
			>{props?.name ?? participant_id}</ActionLink>

			{(display_detail_layer !== false) && (
				<FloatingLayer backButton={() => setDisplayDetailLayer(false)}>
					<div class="without_actions">
						<SingleRegisteredEntry
							{...display_detail_layer}
							basename={'/alerts/'}
							userAction={(a,b,c,d)=>SecurityUserAction(a,b,c,d,props.promotion_id)}
						/>
					</div>
				</FloatingLayer>
			)}
			*/}
		</>
	)
};

const ParticipantDetailLayer = ({ login_id, ...props }) => {
	const [ display_detail_layer, setDisplayDetailLayer ] = useState(false);

	const openDetailLayer = () => {
		$.get(getRemotedbUrl(`/users/get_full_view_data/${props.promotion_id}/${login_id}`), (res) => {
			if(res.status == '1') {
				setDisplayDetailLayer(res.data);
			}
		}, 'JSON');
	};

	return (
		<>
			<ActionLink
				onClick={() => openDetailLayer(login_id)}
			>{props?.name ?? participant_id}</ActionLink>

			{(display_detail_layer !== false) && (
				<FloatingLayer backButton={() => setDisplayDetailLayer(false)}>
					<div class="without_actions">
						<SingleRegisteredEntry
							{...display_detail_layer}
							basename={'/alerts/'}
							userAction={(a,b,c,d)=>SecurityUserAction(a,b,c,d,props.promotion_id)}
						/>
					</div>
				</FloatingLayer>
			)}
		</>
	)
};

const AlertDetailLayer = ({ alert, ...props }) => {
	const [ display_detail_layer, setDisplayDetailLayer ] = useState(false);

	let _extra = Object.entries(alert?.extra ?? {});
	const available_extra_fields = ['email','first_name','last_name'];
	let extra_clean = {};
	_extra.map(([key, value]) => {
		if(available_extra_fields.includes(key))extra_clean[key] = value;
	});
	extra_clean['ip'] = alert?.ip ?? '';
	extra_clean['user_agent'] = (alert?.uagent ?? '').replace('- Sec-Ch-Ua-Full-Version-List:','').replace('\"','"');

	return (
		<>
			<SquaredButton
				icon='knk-visible'
				onClick={() => setDisplayDetailLayer(true)}
				tooltip={<Tooltip with_icon={false} position='left'>View alert detail</Tooltip>}
				aria-label="View details"
			/>

			{(display_detail_layer) && (
				<RawDataViewer
					close={() => setDisplayDetailLayer(false)}
					raw_data={extra_clean}
				/>
			)}
		</>
	)
};

const ColumnCustomContent = (props) => {
	const display = props?.display ?? true;
	if(display === false) return null;

	return (
		<Column {...props} />
	)
};

const ColumnActions = (props) => {
	return (
		<Column {...props} class="gui_text_align_end" />
	)
};

const TableOfContents = ({ items, ...props }) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const combine_columns = props?.combine_columns ?? false;

	const columns = [
		<ColumnCustomContent
			main={true}
			title={i18n("Created")}
			type='date'
		>{props.main_info}</ColumnCustomContent>,
		<ColumnCustomContent
			title={i18n("Type")}
			display={(!combine_columns) ? true : false}
		>{props.type_ribbon}</ColumnCustomContent>,
		<ColumnCustomContent
			title={i18n("IP")}
		>{props.ip_content}</ColumnCustomContent>,
		<ColumnCustomContent
			title={i18n("device", 'ucfirst')}
		>{props.device}</ColumnCustomContent>,
		<ColumnCustomContent
			title={i18n("Action")}
		>{props.alert_action}</ColumnCustomContent>,
		<ColumnCustomContent
			title={i18n("User")}
		>{props.user_login}</ColumnCustomContent>,
		<ColumnActions
			type='actions'
		>{props.actions}</ColumnActions>,
	];

	const default_column_defs = (combine_columns) ? '150px 150px 90px 1fr 1fr 90px' : '150px 120px 150px 1fr 1fr 1fr 90px';

	return (
		<TabledItemsList
			table_id='alerts'
			items={items}
			columns={columns}
			empty_message={props.empty_message}
			max_height='calc(100dvh - 390px - 1em)'
			//sticky_actions={true}
			column_defs={{
				gridTemplateColumns:props?.column_defs ?? default_column_defs,
			}}
			_class={{ other:'not_in_top' }}
		/>
	)
};

const SecurityCenterAlerts = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const owner = useOwner();
	const promotion = owner?.promotion?.Promotion ?? false;
	const blacklisted_ips = props?.blacklisted_ips ?? [];

	const loading = props?.loading ?? false;
	const [ search_ip, setSearchIP ] = useState("");
	const [ search_type, setSearchType ] = useState("");
	
	const [ state, dispatch ] = useFilterData(props.alerts);
	const [ alerts, pagination, goToPage ] = usePaginator(state.filtered, 10);

	if(promotion === false) return null;

	const searchIP = (value) => {
		const filter = {
			key:'search_ip',
			name:"IP",
			tier1:['ip'],
			tier2:{...operators.textOperators},
			tier3:'input',
		};

		dispatch({
			type:'SETFILTER',
			filter:{
				key:'search_ip',
				value,
				operator:'like',
				filter,
			},
			unique:true,
		});

		setSearchIP(value);
	};
	
	const searchType = (value) => {
		const filter = {
			key:'search_type',
			name:"Alert type",
			tier1:['type'],
			tier3:'input',
		};

		dispatch({
			type:'SETFILTER',
			filter:{
				key:'search_type',
				value,
				operator:'like',
				filter,
			},
			unique:true,
		});

		setSearchType(value);
	};

	const exportAlerts = () => {
		alert("TO DO");
	};

	const combine_columns = true;

	const all_alerts = state?.data?.data ?? (state?.data ?? []);	// verificar amb Edgard com fer perquè no torni data.data (2 nivells de data)
	//const all_alerts = state?.data ?? [];

	const alert_types = AlertTypes.filter((obj) => all_alerts.map((al) => al.type).includes(obj.k));
	if(alert_types.length > 1) alert_types.unshift({ k:'', v:i18n("All types") });

	let title_section = i18n("Blocked actions");
	if(!loading && all_alerts.length > 0)title_section += ` (${all_alerts.length})`;

	if(all_alerts.length == 0 && !loading) {
		return (
			<Module>
				<div class="relative_to_container">{i18n("No alerts detected.")}</div>
			</Module>
		)
	}

	return (
		<Module>
			<ModuleHeader
				subtitle={i18n("List of user actions blocked by the promotion's security system.")}
				autotranslate={false}
				actions={<>
					<SearchField
						_field_class="in_top"
						name="search_ip"
						value={search_ip}
						change={(k, v) => searchIP(v)}
						placeholder="Search by IP"
						_class={{ first:true }}
					/>

					{(alert_types.length > 1) && (
						<Select
							name="search_type"
							_field_class="in_top"
							change={(k, v) => searchType(v)}
							value={search_type}
							values={alert_types}
							_class={{ first:true }}
						/>
					)}
					{/*
					<ActionButton
						onClick={exportAlerts}
						icon='knk-download'
					>Export alerts</ActionButton>
					*/}
				</>}
			>{`${title_section}`}</ModuleHeader>
			{(loading) ? (
				<div class="relative_to_container">
					<Spinner
						_class={{other:'gui_pos_rel_important'}}
						force_bg={true}
					>Loading alerts</Spinner>
				</div>
			) : (
				(alerts.length > 0) && (
					<TableOfContents
						items={alerts}
						title={`${i18n("Alerts")}`}
						empty_message={i18n("There are no results.")}
						combine_columns={combine_columns}
						main_info={(item) => {
							const type = alert_types.find((t) => (t.k == item.type));
							if(!type) return null;

							return (
								<div>
									{EPDateFormat(item.created, date_format)}

									{(combine_columns) && (
										<RibbonCollection
											items={[{
												title:type.v,
												color:type.color,
												is_html:true,
												autotranslate:false,
											}]}
										/>
									)}
								</div>
							)
						}}
						type_ribbon={(!combine_columns) ? (item) => {
							const type = alert_types.find((t) => (t.k == item.type));
							if(!type) return null;

							return (
								<RibbonCollection
									items={[{
										title:type.v,
										color:type.color,
										is_html:true,
									}]}
								/>
							)
						} : null}
						ip_content={(item) => {
							const ip_selected = item.ip == search_ip ? true : false;
							const ip_alerts = all_alerts.filter(al => al.ip == (item?.ip ?? '')).map(({created,type,domain}) => ({created,type,information:domain}));
							
							return (
								<div class="link_with_filter">
									<ButtonCollection>
										<ActionLink
											onClick={() => searchIP(!ip_selected ? item.ip : '')}
											icon={ip_selected ? 'knk-off redIcon' : 'knk-filter'}
											_class={{ other:'gui_small_icon gui_pos_rel' }}
											tooltip={<Tooltip with_icon={false} position='top' autotranslate={false}>{!ip_selected ? i18n("***Filter") : i18n("Remove filter")}</Tooltip>}
										/>
									</ButtonCollection>

									<IPDetail
										item={item?.ip ?? ''}
										country={item?.country ?? null}
										is_blocked={blacklisted_ips.includes(item.ip) ? true : false}
										alerts={ip_alerts}
										onBlock={props.onBlock}
										onUnblock={props.onUnblock}
										promotion_id={promotion.id}
										intl={props.intl}
									/>
								</div>
							)
						}}
						device={(item) => {
							return (
								<div>{getDeviceFromUserAgent(item.uagent)}</div>
							)
						}}
						alert_action={(item) => {
							let action_label = "-";
							switch(item.action) {
								case 'vote':
									action_label = <FormattedMessage id="Vote for {user}" values={{ user:<VotedDetailLayer
										participant_id={item.target}
										stage_id={item.stage_id}
										promotion_id={promotion.id}
										name={item?.voted ?? null}
									/> }} />;
									break;

								default:
									action_label = i18n((item?.action ?? "unknown"), 'ucfirst');
									break;
							}

							return (
								<div>{action_label}</div>
							)
						}}
						user_login={(item) => {
							const type = alert_types?.find((t) => (t.k == item.type)) ?? {};

							let user_login = (isNotEmpty(item, 'email')) ? item.email : "-";
							if(type.k == 'phone') user_login = item?.phone ?? "[ No phone ]";
							if(type.k == 'invalid_game'){
								const user_name = item.login_id ? `${item?.extra?.name ?? null}` : null;
								if(user_name) {
									return (
										<ParticipantDetailLayer
											login_id={item.login_id}
											promotion_id={promotion.id}
											name={user_name}
										/>
									)
								}
							}

							return (
								<div>{user_login}</div>
							)
						}}
						actions={(item) => {
							const type = alert_types.find((t) => (t.k == item.type));
							const has_info = type?.has_info ?? false;

							return (
								<ButtonCollection _class={{ other:'gui_flex_end' }}>
									<AlertDetailLayer
										alert={item}
									/>

									<SquaredButton
										icon='knk-information'
										onClick={(has_info) ? () => { props.openAlertLayer(type.k)} : null}
										disabled={(!has_info) ? true : false}
										aria-label="View details"
									/>
								</ButtonCollection>
							)
						}}
						intl={props.intl}
					/>
				)
			)}

			{(pagination.total_pages > 1) && (
				<Paginator
					{...pagination}
					goToPage={goToPage}
				/>
			)}
		</Module>
	);
}

export default injectIntl(SecurityCenterAlerts);